import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./detail.css";
import { Navbar, Button, Nav, Alert } from "react-bootstrap";
import { faCog, faPlus, faShare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Item } from "./components/item";
import { WishlistDetails } from "./components/wishlistDetails";
import {
  deleteItem,
  fetchWishlistDetails,
} from "../../services/WishlistService";
import { AddItemModal } from "./components/addItemModal";
import { EditWishlistModal } from "./components/editWishlistModal";
import { WishlistSettings } from "../../services/WishlistDetails";
import { ThreeDots } from "react-loader-spinner";

interface IItem {
  id: string;
  description: string;
  state: "Wished" | "Promised" | "Verified";
  link: string;
  image: string;
}
interface IWishlistDetailView {
  name: string;
  items: IItem[];
  publicId?: string | undefined;
  description?: string | undefined;
  email?: string | undefined;
}

export const Detail = () => {
  const [wishlist, setWishlist] = useState<IWishlistDetailView>({
    name: "",
    items: [],
    publicId: undefined,
    description: undefined,
    email: undefined
  });

  const [settings, setSettings] = useState<WishlistSettings>();

  const { id } = useParams<{ id: string }>();
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const fetchWishlist = useCallback(() => {
    if (!id) {
      return;
    }
    fetchWishlistDetails(id).then((data) => {
      setWishlist(data);
      setIsLoading(false);
    });
  }, [id]);
  useEffect(() => {
    setSettings({ name: wishlist.name, description: wishlist.description, email: wishlist.email });
  }, [wishlist]);
  useEffect(() => {
    document.title = `ItsyBitsyList - ${wishlist.name}`;
  }, [id, wishlist.name]);

  useEffect(() => {
    fetchWishlist();
  }, [fetchWishlist]);

  const handleDeleteItem = (itemId: string) => {
    if (!id) {
      return;
    }
    deleteItem(id, itemId).then((data) => {
      fetchWishlist();
    });
  };
  const handleHideModal = () => {
    if (showAddModal) setShowAddModal(false);
    else if (showEditModal) setShowEditModal(false);
    fetchWishlist();
  };
  const handleShare = () => {
    const shareUrl = `${window.location.origin}/wishlist/public/${wishlist.publicId}`;
    navigator.clipboard.writeText(shareUrl);
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 2000);
  };
  const handleSettings = () => {
    setShowEditModal(true);
  };

  return (
    <div className="container">
       {isLoading && (
        <div className="loader-container">
          <ThreeDots 
            height="80" 
            width="80" 
            radius="9"
            color="#942323" 
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            visible={true}
            />
        </div>
      )}
      {showAlert && (
        <Alert
          variant="success"
          className="shareAlert fade show position-fixed"
        >
          Link copied to clipboard!
        </Alert>
      )}
      <div>
        <Navbar className="custom-navbar">
          <Navbar.Brand href="#" className="navbar-title">
            {wishlist.name}
          </Navbar.Brand>
          <Button
            variant="outline-light"
            className="addButton"
            onClick={() => setShowAddModal(true)}
          >
            <FontAwesomeIcon icon={faPlus} />
          </Button>
          <Navbar.Toggle aria-controls="navbar-nav" />
          <Navbar.Collapse id="navbar-nav">
            <Nav className="me-auto"></Nav>
            <Nav>
              <Button
                variant="outline-light"
                className="settingsButton"
                onClick={() => handleSettings()}
              >
                <FontAwesomeIcon icon={faCog} />
              </Button>
              <Button
                variant="outline-light"
                className="shareButton"
                onClick={() => handleShare()}
              >
                <FontAwesomeIcon icon={faShare} />
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
      <div className="wishlist">
        <WishlistDetails description={wishlist.description} />
        <hr />
        {!isLoading && wishlist.items.length === 0 && (
          <div className="empty">
            <h2>Your list is empty! Let's add something</h2>
          </div>
        )}
        <div className="wishlist-container">
    {wishlist.items.map((item, idx) => (
      <Item
        key={idx}
        item={item}
        action="delete"
        callback={handleDeleteItem}
      />
    ))}
  </div>
      </div>
      {id && (
        <AddItemModal
          id={id}
          show={showAddModal}
          onHide={() => handleHideModal()}
        />
      )}
      {id && (
        <EditWishlistModal
          id={id}
          show={showEditModal}
          onHide={() => handleHideModal()}
          data={settings}
        />
      )}
      
      <footer className="footer">
        <b>
          Create a new wishlist <a href="/">here</a>. <br />
          Make sure you bookmark this page if you want to edit this later!
        </b>
      </footer>
    </div>
  );
};
